import JSZip from "jszip";
const entryForm = document.getElementById("entry-form");
const nameField = entryForm.querySelector("[name=name]");
const emailField = entryForm.querySelector("[name=email]");
const telField = entryForm.querySelector("[name=tel]");
const resumeField = entryForm.querySelector("[name=resume]");
const movieField = entryForm.querySelector("[name=movie]");
const photo1Field = entryForm.querySelector("[name=phpto1]");
const photo2Field = entryForm.querySelector("[name=phpto2]");
const snsField = entryForm.querySelector("[name=sns]");
const genreField = entryForm.querySelector("[name=genre]");
const dowField = entryForm.querySelector("[name=dow]");
const hourField = entryForm.querySelector("[name=hour]");
const studioField = entryForm.querySelector("[name=studio]");
const submitButton = entryForm.querySelector("[type=submit]");
entryForm.addEventListener("submit", async (e) => {
    var _a, _b, _c;
    e.preventDefault();
    submitButton.disabled = true;
    submitButton.value = "送信中...";
    submitButton.style.cursor = "wait";
    const formData = new FormData();
    formData.append("name", nameField.value);
    formData.append("email", emailField.value);
    formData.append("tel", telField.value);
    formData.append("movie", movieField.value);
    formData.append("sns", snsField.value);
    formData.append("genre", genreField.value);
    formData.append("dow", dowField.value);
    formData.append("hour", hourField.value);
    formData.append("studio", studioField.value);
    const zip = new JSZip();
    if ((_a = resumeField.files) === null || _a === void 0 ? void 0 : _a[0])
        zip.file(resumeField.files[0].name, resumeField.files[0]);
    if ((_b = photo1Field.files) === null || _b === void 0 ? void 0 : _b[0])
        zip.file(photo1Field.files[0].name, photo1Field.files[0]);
    if ((_c = photo2Field.files) === null || _c === void 0 ? void 0 : _c[0])
        zip.file(photo2Field.files[0].name, photo2Field.files[0]);
    const zipData = await zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: {
            level: 9,
        },
    });
    formData.append("files.zip", zipData);
    try {
        const response = await fetch("https://7fzu22pwa1.execute-api.ap-northeast-1.amazonaws.com/Prod/", {
            method: "POST",
            body: formData,
        });
        if (!response.ok)
            throw Error(response.statusText);
        alert("エントリーが完了しました。");
    }
    catch (e) {
        console.error(e);
        alert("送信に失敗しました。ファイルサイズが大きすぎる可能性があります。画像のサイズを小さくして再度お試しいただくか、時間を開けて再度お試しください。");
    }
    finally {
        submitButton.disabled = false;
        submitButton.value = "エントリーする";
        submitButton.style.cursor = "pointer";
    }
});
